import { render, staticRenderFns } from "./DailyBriefingsShow.vue?vue&type=template&id=13385902&"
import script from "./DailyBriefingsShow.vue?vue&type=script&lang=js&"
export * from "./DailyBriefingsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports